import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { Table } from "react-bootstrap";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import moment from "moment";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";

const customStyle = {
  formLabel: {
    fontSize: "14px",
    fontWeight: "600",
  },
  formControl: {
    width: "105px", // Add quotes for numeric values in pixels
    borderRadius: "6px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    color: "#212529",
    border: "1px solid #ced4da",
  },
  formCheckInput: {
    margin: "0",
  },
};
const customIndicator = {
  display: "inline-block",
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  marginBottom: "0px",
  verticalAlign: "middle",
  marginLeft: "10px",
  marginRight: "3px",
  boxShadow: "0 2px 9px 0 rgba(0, 0, 0, 0.18), 0 2px 7px 0 rgba(0, 0, 0, 0.15)",
  border: "solid 2px #fff",
};

const customDatePickerStyle = {
  control: "custom-datepicker-control",
  menu: "custom-datepicker-menu",
  option: "custom-datepicker-option",
  input: "custom-datepicker-input",
};

const TnEInvoiceListTraining = () => {
  const intialInvoiceFilter = {
    clientID: null,
    employeeID: null,
    projectID: null,
  };
  const [filterData, setFilterData] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [projectallocationOption, setProjectAllocationOption] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);

  const handleFilterSelect = (selectedOptions, name) => {
    setFilterData((prevdata) => ({
      ...prevdata,
      [name]: selectedOptions.value,
    }));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("TnE Invoice List (Training)"));
  }, [dispatch]);

  useEffect(() => {
    fetchIndexApi();
    fetchApiData();
  }, []);

  const fetchIndexApi = async () => {
    let response;
    try {
      response = await GetServiceCaller(
        `${API_URL}projectmanagement/list/invoice-listt&etraining`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data?.data;
        const clientOpt = cleanedData?.clients?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setClientOptions(clientOpt);
        const projectOpt = cleanedData?.projects?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setProjectOptions(projectOpt);
        const empOpt = cleanedData?.employee?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setEmployeeOptions(empOpt);
        const allocationTypeOpt = cleanedData?.projectallocationtype?.map(
          (ele) => ({
            value: ele?.value,
            label: ele?.text,
          })
        );

        setProjectAllocationOption(allocationTypeOpt);
      }
    } catch (error) {
      console.error("Fetching Error", error);
    }
  };

  const [apiStatus, setApiStatus] = useState(undefined);
  const fetchApiData = async (filterParams = {}) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/list/invoice-list/t&etraining-getdata?P_ClientID=${filterParams?.clientID || ""
        }&P_ProjectID=${filterParams?.projectID || ""}&P_EmployeeID=${filterParams?.employeeID || ""
        }`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status);
        setAccordionData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error Fetching the Api", error);
    }
  };

  // Single filter handler that uses the same function
  const handleFilter = () => {
    fetchApiData(filterData);
  };

  // Grouping effect - now updates whenever accordionData changes
  useEffect(() => {
    if (accordionData.length > 0) {
      const grouped = accordionData.reduce((acc, item) => {
        const { tmpClientName, tmpProjectName } = item;

        if (!acc[tmpClientName]) {
          acc[tmpClientName] = {};
        }
        if (!acc[tmpClientName][tmpProjectName]) {
          acc[tmpClientName][tmpProjectName] = [];
        }

        acc[tmpClientName][tmpProjectName].push(item);
        return acc;
      }, {});

      setGroupedData(grouped); // Always update with new grouping
    } else {
      setGroupedData({}); // Clear if no data
    }
  }, [accordionData]);

  const handleChange = (e, clientName, projectName, index) => {
    const { name, value } = e.target;
    const inputValue = parseFloat(value) || 0; // Ensure it's a valid number

    setGroupedData((prevData) => {
      return {
        ...prevData,
        [clientName]: {
          ...prevData[clientName],
          [projectName]:
            prevData[clientName]?.[projectName]?.map((item, i) => {
              if (i === index) {
                const basicAmount = parseFloat(item.BasicAmount) || 0;
                const taxPercent =
                  name === "TaxPercent"
                    ? inputValue
                    : parseFloat(item.TaxPercent) || 0;
                const adjustmentAmount =
                  name === "AdjustmentAmount"
                    ? inputValue
                    : parseFloat(item.AdjustmentAmount) || 0;
                const exchangeRate =
                  name === "ExchangeRate"
                    ? inputValue
                    : parseFloat(item.ExchangeRate) || 1;

                let newInvoiceAmount = basicAmount + adjustmentAmount;
                let invoiceWithTax =
                  newInvoiceAmount + (newInvoiceAmount * taxPercent) / 100;
                let invoiceCalculatedAmount = (
                  invoiceWithTax * exchangeRate
                ).toFixed(2);

                return {
                  ...item,
                  [name]: value, // Update changed field
                  InvoiceAmount: newInvoiceAmount,
                  InvoiceCalculatedAmount: invoiceCalculatedAmount,
                };
              }
              return item;
            }) || [],
        },
      };
    });

    // Ensure selectedItems reflect the latest changes
    setSelectedItems((prevSelected) =>
      prevSelected.map((item) => {
        if (
          item.clientName === clientName &&
          item.projectName === projectName &&
          item.index === index
        ) {
          const basicAmount = parseFloat(item.BasicAmount) || 0;
          const taxPercent =
            name === "TaxPercent"
              ? inputValue
              : parseFloat(item.TaxPercent) || 0;
          const adjustmentAmount =
            name === "AdjustmentAmount"
              ? inputValue
              : parseFloat(item.AdjustmentAmount) || 0;
          const exchangeRate =
            name === "ExchangeRate"
              ? inputValue
              : parseFloat(item.ExchangeRate) || 1;

          let newInvoiceAmount = basicAmount + adjustmentAmount;
          let invoiceWithTax =
            newInvoiceAmount + (newInvoiceAmount * taxPercent) / 100;
          let invoiceCalculatedAmount = (invoiceWithTax * exchangeRate).toFixed(
            2
          );
          return {
            ...item,
            [name]: value, // Update changed field
            InvoiceAmount: newInvoiceAmount,
            InvoiceCalculatedAmount: invoiceCalculatedAmount,
          };
        }
        return item;
      })
    );
  };

  const handleCheckBoxChange = (e, clientName, projectName, index) => {
    setSelectedItems((prevSelected) => {
      const isSelected = prevSelected.some(
        (item) =>
          item.clientName === clientName &&
          item.projectName === projectName &&
          item.index === index
      );

      if (isSelected) {
        // Remove the item if it's already selected
        return prevSelected.filter(
          (item) =>
            !(
              item.clientName === clientName &&
              item.projectName === projectName &&
              item.index === index
            )
        );
      } else {
        // Find the latest item from groupedData and add it to selectedItems
        const selectedItem =
          groupedData?.[clientName]?.[projectName]?.[index] || null;

        return selectedItem
          ? [
            ...prevSelected,
            {
              clientName,
              projectName,
              index,
              ...selectedItem, // Always get the latest data
            },
          ]
          : prevSelected;
      }
    });
  };

  const handleSubmit = async () => {
    if (!selectedItems || selectedItems.length === 0) {
      toast.error("Please select at least one item.", {
        position: "top-right",
      });
      return;
    }

    const hasInvalidInvoice = selectedItems.some(
      (item) => !item.InvoiceNo || item.InvoiceNo.trim() === ""
    );

    if (hasInvalidInvoice) {
      toast.error("Each selected item must have a valid InvoiceNo.", {
        position: "top-right",
      });
      return;
    }

    const payloads = selectedItems.map((item, index) => ({
      IsConfirmed: 1,
      BasicAmount: item?.BasicAmount,
      AdjustmentAmount: item?.AdjustmentAmount,
      InvoiceBasedOn_236: item?.InvoiceBasedOn_236,
      LineNo: item?.LineNo,
      ClientID: item?.ClientID,
      ProjectID: item?.ProjectID,
      EmployeeID: item?.EmployeeID,
      PresentDays: item?.PresentDays,
      WorkingDays: item?.WorkingDays,
      InvoicedAmount: Number(item?.InvoicedAmount), // Ensure it's a valid number
      InvoicedDays: item?.InvoicedDays,
      ProjectInvoiceDetailID: item?.ProjectInvoiceDetailID,
      ExchangeRate: Number(item.ExchangeRate),
      InvoiceNo: item?.InvoiceNo || "",
      InvoiceDate: item?.InvoiceDate || "",
      StartDate: item?.StartDate || "",
      EndDate: item?.EndDate || "",
      InvoiceFromDate: item?.InvoiceFromDate || "",
      InvoiceToDate: item?.InvoiceToDate || "",
      PaymentDueDate: item?.PaymentDueDate || "",
      FollowUpDate: item?.FollowUpDate || "",
      PaymentReceivedDate: item?.PaymentReceivedDate || "",
      OverDueDays: item?.OverDueDays || 0,
      TaxPercent: item?.TaxPercent,
      PaymentTermDays: item?.PaymentTermDays,
      OverDueAmount: item?.OverDueAmount || 0,
      InvoiceCalculatedAmount: Number(item?.InvoiceCalculatedAmount) || 0,
      Remarks: item?.Remarks || "", // Ensure it doesn't become `undefined`
    }));

    try {
      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/list/invoice-list/consulting-and-content-getData`,
        { lines: payloads },
        "post"
      );

      if (response?.status === 200) {
        toast.success("Form submitted successfully!", {
          position: "top-right",
        });
      } else {
        toast.error("Failed to submit form. Please try again later.", {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred while submitting the form.", {
        position: "top-right",
      });
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="row">
          <div className="col-md-3">
            <label style={customStyle.formLabel}>Client</label>
            <Select
              name="clientID"
              classNamePrefix="select-sm" // Add this
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "25px",
                  height: "35px",
                }),
              }}
              options={[{ value: null, label: "Select" }, ...clientOptions]}
              onChange={(selectedOptions, action) =>
                handleFilterSelect(selectedOptions, action.name)
              }
            />
          </div>
          <div className="col-md-3">
            <label style={customStyle.formLabel}>Project</label>
            <Select
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "25px",
                  height: "35px",
                }),
              }}
              name="projectID"
              options={[{ value: null, label: "Select" }, ...projectOptions]}
              className="small"
              onChange={(selectedOptions, action) =>
                handleFilterSelect(selectedOptions, action.name)
              }
            />
          </div>
          <div className="col-md-3">
            <label style={customStyle.formLabel}>Employee</label>
            <Select
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "25px",
                  height: "35px",
                }),
              }}
              name="employeeID"
              options={[{ value: null, label: "Select" }, ...employeeOptions]}
              onChange={(selectedOptions, action) =>
                handleFilterSelect(selectedOptions, action.name)
              }
            />
          </div>
          <div className="col-md-3 mt-3 pt-1 text-end ">
            <button className="custom-btn me-2" onClick={handleFilter}>
              Get Data
            </button>
            <button className="custom-btn" type="button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>

        <div className="row mt-3 overflow-auto">
          <div className="table-responsive">
            <Table bordered striped hover>
              <thead className="invoice-table-header">
                <tr>
                  <th>##</th>
                  <th>Inv.Date</th>
                  <th>Invoice#</th>
                  <th>Emp. Name</th>
                  <th>Invoice From Dt</th>
                  <th>Invoice To Dt</th>
                  <th>Remarks/Notes</th>
                  <th>Proforma Amt</th>
                  <th>Tax%</th>
                  <th>Exchange Rate</th>
                  <th>Invoice Amt</th>
                  <th>Pymt.Terms Days</th>
                  <th>Pymt.Due Dt</th>
                  <th>Follow-up Dt</th>
                  <th>Pymt.Recd Dt</th>
                  <th>Overdue Days</th>
                </tr>
              </thead>
              {Object.keys(groupedData).length > 0 && apiStatus === 200 ? (
                <tbody>
                  {Object.entries(groupedData).map(
                    ([clientName, projects], clientIndex) => (
                      <React.Fragment key={clientIndex}>
                        <tr>
                          <td colSpan={22} style={{ padding: "0px" }}>
                            <div
                              className="flex-grow-1 "
                              style={{
                                background: "#27568c",
                                color: "white",
                                padding: "8px",
                                fontWeight: "bold",
                              }}
                            >
                              {clientName}
                            </div>
                          </td>
                        </tr>
                        {Object.entries(projects).map(
                          ([projectName, items], projectIndex) => {
                            const tmpProjectInvoiceDetailNumber =
                              items[0]?.tmpProjectInvoiceDetailNumber || "";
                            const StartDate =
                              (items[0]?.StartDate &&
                                moment(items[0]?.StartDate).format(
                                  "DD-MMM-YYYY"
                                )) ||
                              "";
                            const EndDate =
                              (items[0]?.EndDate &&
                                moment(items[0]?.EndDate).format(
                                  "DD-MMM-YYYY"
                                )) ||
                              "";

                            return (
                              <React.Fragment key={projectIndex}>
                                <tr>
                                  <td
                                    colSpan={22}
                                    style={{
                                      fontWeight: "bold",
                                      padding: "0px",
                                    }}
                                  >
                                    <div
                                      className="flex-grow-1"
                                      style={{
                                        background:
                                          items[0]?.FixedBid === 1
                                            ? "#dbebc7"
                                            : projectallocationOption?.some(
                                              (o) =>
                                                [6706, 6708, 6709].includes(
                                                  o.value
                                                ) &&
                                                o.value ===
                                                items[0]
                                                  ?.ProjectAllocationType_160
                                            )
                                              ? "#DEB887"
                                              : projectallocationOption?.some(
                                                (o) =>
                                                  o.value ===
                                                  items[0]
                                                    ?.ProjectAllocationType_160 &&
                                                  o.value === 1138
                                              )
                                                ? "#deb887"
                                                : "#c3d6eb",
                                        color: "black",
                                        padding: "8px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {`${projectName}: `}
                                      {tmpProjectInvoiceDetailNumber
                                        ? ` (SOW/PO/SO: ${tmpProjectInvoiceDetailNumber} ${StartDate} - ${EndDate})`
                                        : ""}
                                    </div>
                                  </td>
                                </tr>
                                {items.map((data, subIndex) => (
                                  <tr key={subIndex} className="border">
                                    <td style={{ width: "40px" }}>
                                      <input
                                        type="checkbox"
                                        style={customStyle.formCheckInput}
                                        checked={selectedItems.some(
                                          (item) =>
                                            item.clientName === clientName &&
                                            item.projectName === projectName &&
                                            item.index === subIndex
                                        )}
                                        onChange={(e) =>
                                          handleCheckBoxChange(
                                            e,
                                            clientName,
                                            projectName,
                                            subIndex,
                                            data
                                          )
                                        }
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.InvoiceDate}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.InvoiceNo}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.tmpEmployeeName}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.InvoiceFromDate}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.InvoiceToDate}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.Remarks}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.InvoicedAmount}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.TaxPercent}
                                      />
                                    </td>
                                    <td style={{ width: "60px" }}>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        value={data?.ExchangeRate}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        disabled
                                        className="text-end"
                                        style={customStyle.formControl}
                                        value={data?.InvoicedAmount}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        disabled
                                        className="text-end"
                                        style={customStyle.formControl}
                                        value={data?.PaymentTermDays}
                                      />
                                    </td>

                                    <td>
                                      <input
                                        disabled
                                        type="text"
                                        style={customStyle.formControl}
                                        value={data?.PaymentDueDate}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      <input
                                        disabled
                                        type="text"
                                        style={customStyle.formControl}
                                        value={data?.FollowUpDate}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      <input
                                        disabled
                                        type="text"
                                        style={customStyle.formControl}
                                        value={data?.FollowUpDate}
                                        readOnly
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        disabled
                                        className="text-end"
                                        style={customStyle.formControl}
                                        value={data?.PaymentReceivedDate}
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        style={customStyle.formControl}
                                        disabled
                                        name="InvoiceAmount"
                                        className="text-end"
                                        value={data?.OverDueDays}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            );
                          }
                        )}
                      </React.Fragment>
                    )
                  )}
                </tbody>
              ) : apiStatus === undefined ? (
                <tbody>
                  <tr>
                    <td colSpan={22} className="text-center py-4">
                      <div className="d-flex flex-column align-items-center">
                        <FaSpinner className="spinner mb-2" />
                        <span>Loading</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : apiStatus === 200 && Object.keys(groupedData).length === 0?
              
              <tbody>
                  <tr>
                    <td colSpan={22} className="text-center py-4">
                      <div className="d-flex flex-column align-items-center">
                        N0 Data Found
                      </div>
                    </td>
                  </tr>
                </tbody>
              
              :null}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TnEInvoiceListTraining;
